<template>
  <div class="py-3">
    <h4> {{ $route.params.item == 3 ? 'Booker Overview' : 'Booker Timing' }}</h4>
    <div
      class="mx-2"
      v-if="['1', '9'].includes(currentUser.role_id) || isBdrUser()"
    >
      <div class="col-md-12 px-0">
        <div
          class="container-fluid w-100 mb-5 p-3 border bg-white rounded stats-wrapper"
        >

          <div class="row">
            <div class="col-12 col-md-2 input-group input-group-sm p-1">
              <div class="input-group-prepend">
                <span class="input-group-text" id="inputGroup-sizing-sm"
                  >Date</span
                >
              </div>
              <date-picker
                id="startDatePicker"
                class="form-control"
                v-model="filterMonth"
                :config="datePickerConfig"
                placeholder="Start Date"
              ></date-picker>
            </div>

            <div class="col-12 col-md-2 input-group input-group-sm p-1 treeselect-wrapper" v-if="!isBdrUser()">
              <div class="input-group-prepend">
                <span class="input-group-text" id="inputGroup-sizing-sm"
                  >BDR</span
                >
              </div>
              <treeselect
                v-model="bdr_user_id"
                :options="bdr_users"
                :multiple="false"
                :clearable="false"
                :normalizer="normalizeOptions"
                class="form-control inline-table"
                @change="changeBDR"
              >
              </treeselect>
            </div>

            <div class="col-12 col-md-3 input-group input-group-sm p-1 treeselect-wrapper" v-if="!isBdrUser()">
              <div class="input-group-prepend">
                <span class="input-group-text" id="inputGroup-sizing-sm"
                  >{{ $t("lang.label.filter-task_type") }}</span
                >
              </div>
              <treeselect
                v-model="taskTypeFilter"
                :options="taskTypeOptions"
                :multiple="true"
                class="form-control inline-table"
              />              
            </div>

            <!-- CLIENTS -->
            <div class="col-12 col-md-3 input-group input-group-sm p-1 treeselect-wrapper">
              <div class="input-group-prepend">
                <span class="input-group-text" id="inputGroup-sizing-sm">
                  Clients
                </span
                >
              </div>
              <treeselect 
                v-model="clientsSelected" 
                class="form-control inline-table"
                :options="filteredClients" 
                :multiple="true"
                :searchable="true" 
                :clearable="true" 
                :loading="isLoading" 
                placeholder="Search and select clients" label="label" track-by="id"   
                @search-change="onSearchChange">
              </treeselect>
            </div>

            <div class="col-12  col-md-2">
              <button
              class="btn btn-success ml-3 w-100"
              @click="changeBDR()"
              :disabled="loading"
              >
              <i class="icon-calendar-check-o mr-2 d-inline-block"></i>
              <small>
                {{ $t("lang.button.filter") }}
              </small>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <LoadingSpinner v-if="loading" />

    <div class="row" v-else>
      <div class="col-sm-12 mt-5">
        <div class="table-responsive">
          <div v-for="(parent, key) in parents" :key="parent + key">
            <div class="pb-4 max-content table-sticky-1col">
              <h3 class="ml-3">{{ parent.parent_name }}</h3>
              <div class="table-sticky-1col">
                <StatsTable
                  :statsClient="statsClient[parent.parent_name]"
                  :statsType="getStatsTypeByParent(parent.parent_name)"
                  :statsDate="statsDate"
                  :showTotal="
                    parent.parent_name == 'Meeting Rate' ? false : true
                  "
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { opportunitiesService, usersService, monitorService } from "@/_services";
import StatsTable from "@/components/Usages/StatsTable.vue";
import { mapState } from "vuex";
import moment from "moment";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

export default {
  props: {
    type: String,
    targetId: {
      type: String,
      default: "0",
    },
  },
  components: {
    StatsTable,
    LoadingSpinner,
    Treeselect,
  },
  data() {
    return {
      clientsSelected:[],
      isLoading: false,
      filteredClients: [],
      clients:[],
      taskTypeOptions: [
        {
          id: "coldphoning",
          label: this.$t("lang.task.callcontact_title")
        },
        {
          id: "manualanswer",
          label: this.$t("lang.task.manualanswer_title")
        },
        {
          id: "reminder",
          label: "Reminder Task"
        },
        {
          id: "absent",
          label: "Absent Event"
        },
        {
          id: "calendar",
          label: "Calendar activity with no event"
        },
        {
          id: "cancelled",
          label: "Cancelled Event"
        }
      ],
      loading: true,
      statsClient: {},
      statsDate: [],
      parents: [],
      statsType: [
        // {
        //   id: "gmail_gmail",
        //   label: "gmail > gmail",
        //   format: "percentage",
        //   showQty: false,
        //   showTotal: false,
        //   parent: "sent",
        // },
      ],
      selectUserBdr: false,
      bdr_user_id: null,
      taskTypeFilter: [],
      bdr_users: null,
      datePickerConfig: {
        format: "YYYY-MMM",
        // useCurrent: false,
        viewMode: "months",
        minDate: moment().subtract(12, "month"),
        maxDate: moment().endOf("day"),
      },
      filterMonth: moment().format("YYYY-MMM"),
      // range: {
      //   startDate: moment().subtract(1, "month").format("YYYY-MM-DD"),
      //   endDate: moment().format("YYYY-MM-DD"),
      // },
    };
  },

  computed: {
    ...mapState({
      currentUser: (state) => state.authentication.user,
    }),
  },
  created() {
    this.getClients()
    this.getUserBdr();
    this.changeBDR();
  },
  methods: {
    getClients() {
      const toCreateUser = 1;
      monitorService.getClients(null, "2,3,4,5,9", toCreateUser)
        .then(res => {
          this.clients = res
        })
        .catch(err => console.log(err));
    },
    onSearchChange(searchQuery) {
      if (searchQuery.length > 1) {
        const query = searchQuery.toLowerCase();
        this.filteredClients = this.clients.filter((client) =>
          client.label.toLowerCase().includes(query)
        );
      } else {
        this.filteredClients = []
      }
    },
    isBdrUser() {
      return (
        this.currentUser.team_role_id == 2 && this.currentUser.role_id == 2
      );
    },
    mergeObjects(statsX, statsX2) {
      statsX2.forEach((item2) => {
        let item = statsX.find((item) => item.fdate == item2.fdate);
        if (item) {
          Object.assign(item, item2);
        } else {
          statsX.push(item2);
        }
      });
      return statsX;
    },
    changeBDR() {
      this.loading = true;
      this.statsClient = {};
      this.statsDate = [];
      this.parents = [];
      this.statsType = [];

      const userBdr = this.isBdrUser() ? this.currentUser.id : this.bdr_user_id;

      opportunitiesService
        .getBookersHistory({
          clients: this.clientsSelected,
          taskTypeFilter: this.taskTypeFilter,
          bdr_user_id: userBdr,
          month: this.filterMonth,
          type: this.type,
          target_id: this.targetId,
        })
        .then((res) => {
          if (res["doneTasks"] !== null) {
            let statsX = this.formatData(
              res["newTasks"],
              "total_tasks",
              "New Tasks",
              "qty"
            );

            let statsX1 = this.formatData(
              res["newTasks"],
              "residual_tasks",
              "Residual Tasks",
              "qty"
            );

            let statsX2 = this.formatData(
              res["doneTasks"],
              "total_tasks",
              "Done Tasks",
              "qty"
            );
            let statsX3 = this.formatData(
              res["doneTasks"],
              "total_opps",
              "Managed opportunities",
              "qty"
            );
            let statsX4 = this.formatData(
              res["doneTasks"],
              "total_verified_tasks",
              "Verified tasks",
              "qty"
            );

            statsX = this.mergeObjects(statsX, statsX1);
            statsX = this.mergeObjects(statsX, statsX2);
            statsX = this.mergeObjects(statsX, statsX3);
            statsX = this.mergeObjects(statsX, statsX4);

            statsX2 = this.formatData(
              res["doneTasks"],
              "total_meetings",
              "Meetings booked",
              "qty"
            );

            statsX = this.mergeObjects(statsX, statsX2);

            statsX2 = this.formatData(
              res["doneTasks"],
              ["total_meetings", "total_verified_tasks"],
              "Meeting Rate",
              "rate"
            );

            statsX = this.mergeObjects(statsX, statsX2);

            statsX.forEach((item) => {
              const client_id = item.client_id ? item.client_id : 0;
              const client_name = item.client_name ? item.client_name : "";
              const fdate = item.fdate;

              if (!this.statsDate.find((field) => field.date == fdate)) {
                this.statsDate.push({ date: fdate });
              }

              this.statsType.forEach((statType) => {
                let type = statType.id + "_" + statType.format;
                let parent = statType.parent;

                if (
                  !this.parents.find((field) => field.parent_name == parent)
                ) {
                  this.parents.push({ parent_name: parent });
                }

                if (this.statsClient[parent] == undefined) {
                  this.statsClient[parent] = {};
                }
                if (this.statsClient[parent][client_id] == undefined) {
                  this.statsClient[parent][client_id] = {};
                  this.statsClient[parent][client_id]["name"] = client_name;
                }
                if (this.statsClient[parent][client_id][fdate] == undefined) {
                  this.statsClient[parent][client_id][fdate] = item;
                }

                if (item[type] !== undefined && item[type] !== null) {
                  if (this.statsClient[parent][client_id][type] === undefined) {
                    this.statsClient[parent][client_id][type] = 0;
                    this.statsClient[parent][client_id][type + "_total"] = 0;
                  }
                  this.statsClient[parent][client_id][type] += parseFloat(
                    item[type]
                  );
                  this.statsClient[parent][client_id][type + "_total"]++;
                }
              });
            });

            this.statsDate.sort((a, b) => a.date - b.date);

            this.statsType.forEach((statType) => {
              let type = statType.id + "_" + statType.format;
              let parent = statType.parent;

              if (["avg", "percentage", "rate"].includes(statType.format)) {
                // arreglar promedio

                this.statsClient[parent][0][type] =
                  this.statsClient[parent][0][type] /
                  this.statsClient[parent][0][type + "_total"];
              }
            });
          }

          this.loading = false;
        });
    },
    getUserBdr() {
      usersService
        .getBdrs()
        .then((res) => {
          this.bdr_users = res.result;
        })
        .catch((err) => consolelog(err));
    },
    normalizeOptions(node) {
      return {
        id: node.id,
        label: node.name,
      };
    },
    formatData(x, field_value, parent, format_type) {
      let statsX = [];
      let total = 0;
      let total1 = 0;
      let total2 = 0;
      x.forEach((item) => {
        const fdate = item.fdate;
        if (!statsX.find((field) => field.fdate == fdate)) {
          statsX.push({ fdate: fdate });
        }
        let statWeek = statsX.find((field) => field.fdate == fdate);
        let label = item.name;
        let key = label + "_" + parent;

        let value = 0;
        if (Array.isArray(field_value)) {
          if (item[field_value[1]] > 0) {
            let val0 = parseInt(item[field_value[0]]);
            let val1 = parseInt(item[field_value[1]]);
            total1 += val0;
            total2 += val1;
            total = total1 / total2;
            value = val0 / val1;
            if (["percentage", "rate"].includes(format_type)) {
              value = value * 100;
            }
          }
        } else {
          value = item[field_value];
        }

        statWeek[key + "_" + format_type] = value;
        if (Array.isArray(field_value)) {
          statWeek["Total_" + parent + "_" + format_type] = total * 100;

          if (!this.statsType.find((field) => field.id == "Total_" + parent)) {
            this.statsType.push({
              id: "Total_" + parent,
              label: "Total",
              format: format_type,
              showQty: false,
              showTotal: true,
              parent: parent,
              className: "font-weight-bold",
            });
          }
        }

        if (!this.statsType.find((field) => field.id == key)) {
          this.statsType.push({
            id: key,
            label: label,
            format: format_type,
            showQty: false,
            showTotal: true,
            parent: parent,
          });
        }
      });
      return statsX;
    },

    getStatsTypeByParent(parent) {
      if (this.type == "timing") {
        let x = this.statsType.filter((e) => e.parent === parent);

        const entries = Object.entries(x);

        entries.sort(([keyA, valueA], [keyB, valueB]) => {
          let a = valueA.label == "Total" ? 9999 : parseInt(valueA.label);
          let b = valueB.label == "Total" ? 9999 : parseInt(valueB.label);
          return a - b;
        });

        return entries.map(([, value]) => value);
      } else {
        let x = this.statsType.filter((e) => e.parent === parent);
        const customOrder = [
          "Reschedule",
          "Urgent",
          "Positive",
          "Calendar inspection",
          "Introduction",
          "Wrong contact",
          "Negative",
          "Cold",
          "Other Answer",
          "Total",
        ];

        const entries = Object.entries(x);

        entries.sort(([keyA, valueA], [keyB, valueB]) => {
          const indexA = customOrder.indexOf(valueA.label);
          const indexB = customOrder.indexOf(valueB.label);
          return (
            (indexA === -1 ? Infinity : indexA) -
            (indexB === -1 ? Infinity : indexB)
          );
        });

        return entries.map(([, value]) => value);
      }
    },
    getRate(a, b) {
      if (b == 0) {
        return 0;
      } else {
        return (parseFloat(a) / parseFloat(b)) * 100;
      }
    },
  },
};
</script>
